module.exports = __webpack_public_path__ + "static/media/dashboard.cc1efe97.svg";